import { nextTick } from 'vue';
import type { RouteLocationNormalized, Router } from 'vue-router';

import { scrollAppToTop } from '@/helpers/scrollAppToTop';

export function shouldScrollAppToTop(to: RouteLocationNormalized): boolean {
  return to.matched.some(record => record.meta.scrollToTop === true);
}

export function registerRouterScrollToTop(router: Router): void {
  router.afterEach((to, _from, failure) => {
    if (failure || !shouldScrollAppToTop(to)) {
      return;
    }

    nextTick(scrollAppToTop);
  });
}
